export function generateCustomContainerCss() {
  return `
    #transakIframe{
      width: 100%;
      height: 100%;
      border: none;
    }
  `;
}
